var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAk40(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 58.8 30",
    style: {
      enableBackground: "new 0 0 58.8 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.2,18.4v-2.2H6.3v-1l4.1-5.8h0.9v5.8h1.2v1h-1.2v2.2H10.2z M10.2,15.2v-4.1l-2.8,4.1H10.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: -6.7,
    transform: "matrix(0.4722 -0.8815 0.8815 0.4722 0.5025 15.8753)",
    width: 1,
    height: 28.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: 20.9,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -8.8487 9.7122)",
    width: 28.5,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.6,
    y: 11,
    width: 3.6,
    height: 8.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,30H0V0h30V30z M1,29H29V1H1V29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5,25.9H4V3.8h22.5V25.9z M4.9,25h20.8V4.6H4.9V25z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.8,
    y: -6.7,
    transform: "matrix(0.4722 -0.8815 0.8815 0.4722 15.6732 41.2132)",
    width: 1,
    height: 28.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.2,
    y: 20.9,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -5.0059 24.0702)",
    width: 28.5,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7,30h-30V0h30V30z M29.7,29h28.1V1H29.7V29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3,25.9H32.8V3.8h22.5V25.9z M33.6,25h20.8V4.6H33.6V25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAk40);
export default __webpack_public_path__ + "static/media/ak_4_0.63a08a0897b719ccbcc05a1d41c71553.svg";
export { ForwardRef as ReactComponent };